export const CONTACT_PHONE_DISPLAY = '310 441 5759';
export const CONTACT_PHONE_WHATSAPP = '573104415759';

const WHATSAPP_MESSAGE = 'Hola, me gustaría agendar una consulta con Sustento Jurídico.';

export const WHATSAPP_URL = `https://wa.me/${CONTACT_PHONE_WHATSAPP}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
